<template>
  <div>
    <v-card
      color="white" class="ma-2"
    >
      <v-card-title class="blue darken-2 white--text">Daftar Registrasi Rekanan</v-card-title>

      <v-card-title>
          <v-text-field v-model="search" prepend-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
          class="elevation-1"
          :search="search"
          :headers="headers"
          :items="lsVendor"
          :items-per-page="10"
          :single-select="true"
          item-key="id"
          height="400"
            fixed-header
      >
          <template v-slot:item.bentuk="{item}">
            {{ bentukCap(item.bentuk) }}
          </template>
          <template v-slot:item.status="{item}">
            {{ statusCap(item.status) }}
          </template>
          <template v-slot:item.actions="{item}">
              <v-chip dark color="green" v-if="item.status === 'A'">
                <v-avatar left>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>Sudah Verifikasi
              </v-chip>
              <v-chip dark color="orange" v-if="item.status === 'N'">
                <v-avatar left>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>Persiapan
              </v-chip>
              <v-btn @click="prosesVendor(item.id, item.nama, bentukCap(item.bentuk), item.vendorType)" v-if="item.status === 'V'">Verifikasi</v-btn>
          </template>
      </v-data-table>

    </v-card>


    <v-dialog v-model="isPerson" max-width="1000" persistent>
      <v-card>
        <v-card-title class="green accent-2"> Verifikasi Rekanan: {{ personName }} </v-card-title>
        <VerifikasiPerson v-if="personId" :vendorId="personId" />
        <v-card-actions>
          <v-btn class="blue" @click="isPerson = false" dark>Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Verifikasi></Verifikasi>


  </div>
</template>

<script>
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API
import { itemsBentukUsaha, statusVendor } from './../../lib/viewLib'
import { evBus } from '@/main'

//components
import Verifikasi from './../../components/user/Verifikasi'
import VerifikasiPerson from "./../../components/user/VerifikasiPerson"


export default {
  name: 'UserHome',
  components: { Verifikasi, VerifikasiPerson },
  data: function() {
    return {
      // Data table
      search: "",
      headers: 
      [
          { text: "Nama Perusahaan", value: "nama", class: "yellow lighten-3 subtitle-2" },
          { text: "No. Registrasi", value: "id", class: "yellow lighten-3 subtitle-2" },
          { text: "Bentuk", value: "bentuk", class: "yellow lighten-3 subtitle-2" },
          { text: "Alamat", value: "alamat", class: "yellow lighten-3 subtitle-2" },
          { text: "Status", value: "status", class: "yellow lighten-3 subtitle-2" },
          { text: "", value: "actions", sortable: false, class: "yellow lighten-3 subtitle-2" }
      ],
      lsVendor: [],
      isPerson: false,
      personId: null,
      personName: "",
    }
  },
  methods: {
    bentukCap: bentuk => itemsBentukUsaha.find(el => el.value === bentuk).text,
    statusCap: status => statusVendor.find(el => el.status === status).caption,
    prosesVendor: function(id, nama, bentuk, type) {
      this.$store.commit('ven/setId', id)
      this.$store.commit('ven/setName', nama)

      if (type === 'O') {
        console.log("Verifikasi Perseorangan: ", id, nama);
        this.isPerson = true;
        this.personId = id;
        this.personName = nama;
      }
      else {
        this.isPerson = false;
        this.personId = null;
        this.personName = "";
        evBus.$emit('dlgVerifikasi', { id: id, nama: nama, bentuk: bentuk })
      }
    }
  },
  created: async function() {
    await axios.get(apiUrl + '/vendor/registrasi/perusahaan')
    .then((response) => {
      this.lsVendor = response.data.data.rows
    })
    .catch((error) => {
      console.log(error)
    })
  }
}
</script>

<style>

</style>